import { LTS_DISPLAYED_RELEASES } from 'constants.js';
import { FR_DISPLAYED_RELEASES } from 'constants.js';

/** Uses the set of product + platform combinations in productTree to generate an object with
 * the number of releases that should be displayed for either the LTS or FR tables.
 * The base value for all product + platform combinations is obtained from the global 
 * constants LTS_DISPLAYED_RELEASES and FR_DISPLAYED_RELEASES. Values for a specific product +
 * platform combinations can be set in the corresponding object.
 */
export function setDisplayedReleases(productTree, releaseType) {
    let baseNumReleases = 0;
    let filteredProducts = new Set();
    let numDisplayedReleases = {};

    if (releaseType === 'LTS') {
      baseNumReleases = LTS_DISPLAYED_RELEASES;
    } else if (releaseType === 'FR') {
      baseNumReleases = FR_DISPLAYED_RELEASES;
    }

    productTree.forEach(entry => {
      entry = entry.split(',');
      if (entry.length < 3) {
        return entry; // filters out product/platform header entries
      } else {
        let product = entry[1];
        let platform = entry[2];
        filteredProducts.add(product + "," + platform);
      }
    });
    
    filteredProducts.forEach(entry => {
      entry = entry.split(',');
      let product = entry[0];
      let platform = entry[1];

      try {
        numDisplayedReleases[product][platform] = baseNumReleases;
      } catch {
        numDisplayedReleases[product] = {[platform]: baseNumReleases};
      }
    });

    // Set the number of displayed releases for specific products
    numDisplayedReleases['Agent']['Windows'] = baseNumReleases * 2;
    numDisplayedReleases['Agent']['Amazon 2'] = baseNumReleases * 2;
    numDisplayedReleases['Agent']['amzn2023'] = baseNumReleases * 2;
    numDisplayedReleases['Agent']['Solaris_5.10_U5'] = baseNumReleases * 2;
    numDisplayedReleases['Agent']['Solaris_5.10_U7'] = baseNumReleases * 2;
    numDisplayedReleases['Agent']['Solaris_5.11'] = baseNumReleases * 2;
    numDisplayedReleases['Agent']['Solaris_5.11_U4'] = baseNumReleases * 2;
    numDisplayedReleases['Agent']['Oracle_OL6'] = baseNumReleases * 2;
    numDisplayedReleases['Agent']['RedHat_EL6'] = baseNumReleases * 2;
    numDisplayedReleases['Agent']['RedHat_EL8'] = baseNumReleases * 3;
    numDisplayedReleases['Agent']['Ubuntu_18.04'] = baseNumReleases * 2;
    numDisplayedReleases['Agent']['Ubuntu_20.04'] = baseNumReleases * 2;
    numDisplayedReleases['Agent']['Ubuntu_22.04'] = baseNumReleases * 2;
    numDisplayedReleases['Agent']['SuSE_12'] = baseNumReleases * 2;
    numDisplayedReleases['Agent']['SuSE_15'] = baseNumReleases * 3;

    
    return numDisplayedReleases
}
